import React, { useContext } from 'react';
import { useForm } from 'react-hook-form';
import {
  Grid,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { Delete, Edit } from '@mui/icons-material';
import { dropBoolean } from 'utils/drops';
import { useDialog } from 'components/Modals';
import { ProdutosContext } from 'contexts/ProdutosContext';
import Card from 'components/Card';
import Input from 'components/Input';
import Button from 'components/Button';
import Dropdown from 'components/Dropdown';
import TableContainer from 'components/TableContainer';
import styles from '../styles';

const Variações = ({ loading, onSubmit, produtoMl = {}, disableActions }) => {
  const { openDialog } = useDialog();

  const Modal = ({ item }) => {
    const defaultValues = {
      type: item?.type || null,
      value: item?.value || [],
    };
    const { control, handleSubmit } = useForm({ defaultValues });
    //   const { postLoading } = useContext(ProdutosContext);

    return (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="h6" component="div" align="center">
            Informações Gerais
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Dropdown
            name="type"
            control={control}
            label="Tipo de Variação"
            options={produtoMl?.variationAttributes?.map((v) => ({
              value: v?.id,
              label: v?.name,
            }))}
          />
        </Grid>
        {/* <Grid item xs={12}>
          <Dropdown
            name="value"
            control={control}
            label="Variações"
            multiple
            options={produtoMl?.variationAttributes?.map((v) => ({
              value: v?.id,
              label: v?.name,
            }))}
          />
        </Grid> */}
        {/* <Grid item xs={12} textAlign="center">
          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit((data) => onSubmit({ Variacoes: [data] }))}
            loading={postLoading}
          >
            Salvar
          </Button>
        </Grid> */}
      </Grid>
    );
  };

  return (
    <Card title="Variações" style={styles?.card}>
      <Grid container spacing={2}>
        {!disableActions && (
          <Grid item xs={12} textAlign="center">
            <Button
              variant="outlined"
              color="primary"
              onClick={() => openDialog(<Modal />, 'Adicionar Variação')}
            >
              Adicionar
            </Button>
          </Grid>
        )}
        {/* {!!produto?.ProdutoVariacaos?.length && (
          <Grid item xs={12}>
            <TableContainer>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Variação</TableCell>
                    <TableCell>Ativo</TableCell>
                    <TableCell align="center">Ações</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {produto?.ProdutoVariacaos?.map((item) => (
                    <TableRow key={item?.id?.toString()}>
                      <TableCell>{item?.variacao}</TableCell>
                      <TableCell>{item?.ativo}</TableCell>
                      <TableCell align="center">
                        {!disableActions && (
                          <IconButton
                            size="small"
                            onClick={() =>
                              openDialog(
                                <Modal item={item} />,
                                'Editar Variação'
                              )
                            }
                          >
                            <Edit />
                          </IconButton>
                        )}
                        {!disableActions && (
                          <IconButton
                            size="small"
                            onClick={() => onDelete({ rotina, id: item?.id })}
                          >
                            <Delete />
                          </IconButton>
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        )} */}
      </Grid>
    </Card>
  );
};

export default Variações;
